// @lib-export
class FileVo {
    constructor(identityKey, name, contentType, storageType, url, lastModifiedDate, data, authorExternalId) {
        this.identityKey = identityKey;
        this.name = name;
        this.contentType = contentType;
        this.lastModifiedDate = lastModifiedDate;
        this.data = data;
        this.authorExternalId = authorExternalId;
        this.storageType = storageType;
        this.url = url === `null` ? null : url;
    }
}

export { FileVo };
//# sourceMappingURL=file-vo.js.map
